import './FiscalTable.css';

function Coluna(props: any) {
    if (props.linha === 0) {
        return (<th className='relFiscal'>{props.model}</th>);
    }
    else {
        return (<td className='relFiscal'>{props.model}</td>);
    }
}

function Linha(props: any) {
    return (<tr className='relFiscal'>
        <Coluna model={props.model[0]} linha={props.linha} />
        <Coluna model={props.model[1]} linha={props.linha} />
        <Coluna model={props.model[2]} linha={props.linha} />
        <Coluna model={props.model[3]} linha={props.linha} />
        <Coluna model={props.model[4]} linha={props.linha} />
        <Coluna model={props.model[5]} linha={props.linha} />
        <Coluna model={props.model[6]} linha={props.linha} />
        <Coluna model={props.model[7]} linha={props.linha} />
        <Coluna model={props.model[8]} linha={props.linha} />
    </tr>
    )
}

function ColunaCfop(props: any) {
    if (props.linha === 0) {
        return (<th className='relFiscalResumo'>{props.model}</th>);
    }
    else {
        return (<td className='relFiscalResumo'>{props.model}</td>);
    }
}

function LinhaCfop(props: any) {
    return (<tr className='relFiscalResumo'>
        <ColunaCfop model={props.model[0]} linha={props.linha} />
        <ColunaCfop model={props.model[1]} linha={props.linha} />
        <ColunaCfop model={props.model[2]} linha={props.linha} />
    </tr>
    )
}

function ColunaPeriodo(props: any) {
    if (props.linha === 0) {
        return (<th className='relFiscalResumo'>{props.model}</th>);
    }
    else {
        const isCancelada = props.situacao === 'Cancelada';
        return (<td className={`relFiscalResumo${isCancelada ? ' relFiscalCancelada' : ''}`}>{props.model}</td>);
    }
}

function LinhaPeriodo(props: any) {
    return (<tr className='relFiscalResumo'>
        <ColunaPeriodo model={props.model[0]} linha={props.linha} situacao={props.model[1]} />
        <ColunaPeriodo model={props.model[1]} linha={props.linha} situacao={props.model[1]} />
        <ColunaPeriodo model={props.model[2]} linha={props.linha} situacao={props.model[1]} />
        <ColunaPeriodo model={props.model[3]} linha={props.linha} situacao={props.model[1]} />
        <ColunaPeriodo model={props.model[4]} linha={props.linha} situacao={props.model[1]} />
    </tr>
    )
}

type FiscalTableProps = {
    cupons: any[];
    totalPorCfop: any[];
    totalPorPeriodo: any[];
};

export default function FiscalTable(props: FiscalTableProps) {
    const { cupons, totalPorCfop, totalPorPeriodo } = props;

    if (!cupons || cupons.length <= 1) {
        return (<div>Não há dados para a data pesquisada</div>);
    }

    return (
        <div>
            {/* Tabela principal: Cupons Emitidos */}
            <table className="centerFiscal">
                {cupons.map((valor: any, index: any) => {
                    return <Linha key={`cupom-${index}`} model={valor} linha={index} />
                })}
            </table>

            {/* Total Geral por CFOP */}
            {totalPorCfop && totalPorCfop.length > 1 && (
                <>
                    <div className="relFiscalResumoTitle">Total Geral por CFOP</div>
                    <table className="centerFiscalResumo">
                        {totalPorCfop.map((valor: any, index: any) => {
                            return <LinhaCfop key={`cfop-${index}`} model={valor} linha={index} />
                        })}
                    </table>
                </>
            )}

            {/* Total do Período */}
            {totalPorPeriodo && totalPorPeriodo.length > 1 && (
                <>
                    <div className="relFiscalResumoTitle">Total do Período</div>
                    <table className="centerFiscalResumo">
                        {totalPorPeriodo.map((valor: any, index: any) => {
                            return <LinhaPeriodo key={`periodo-${index}`} model={valor} linha={index} />
                        })}
                    </table>
                </>
            )}
        </div>
    );
}
